import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-body-operario',
  templateUrl: './body-operario.component.html',
  styleUrls: ['./body-operario.component.css']
})
export class BodyOperarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
